import { render, staticRenderFns } from "./ComitePagination.vue?vue&type=template&id=f922176c&"
import script from "./ComitePagination.vue?vue&type=script&lang=js&"
export * from "./ComitePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports